module.exports = __webpack_public_path__ + "img/eabe51c.jpg";